import { jwtDecode } from "jwt-decode";
import { User } from "oidc-client-ts";

import { getMockPerms } from "./localStorageUtils";
import { getClientId, getIdAuthority, getMockMode } from "./runtimeConfig";

export const isRoutePermitted = (
	userPerms = {},
	pagePerms,
	isSysAdmin = false
) => {
	if (!pagePerms) return true;

	if (isSysAdmin) {
		const mockPerms = getMockPerms();
		if (mockPerms) {
			userPerms = getMockPerms();
			isSysAdmin = false;
		}
	}

	for (const perm in pagePerms) {
		if (perm === "org") {
			let hasOrgPerm = false;

			for (const orgPerm in pagePerms[perm]) {
				if (userPerms[orgPerm] === pagePerms[perm][orgPerm]) {
					hasOrgPerm = true;
					break;
				}
			}

			if (!hasOrgPerm) return false;
		}

		if (userPerms[perm] === pagePerms[perm] || isSysAdmin) {
			return true;
		}
	}
	return false;
};

export const getIsSysAdmin = () => {
	if (getMockMode()) return true;

	const oidcStorage = sessionStorage.getItem(
		`oidc.user:${getIdAuthority()}:${getClientId()}`
	);
	if (!oidcStorage) {
		return false;
	}
	const user = User.fromStorageString(oidcStorage);
	const authToken = user?.access_token;
	let isSysAdmin = false;
	if (authToken) {
		const jwt = jwtDecode(authToken);
		if (typeof jwt.role === "string") {
			isSysAdmin = jwt.role === "sysadmin";
		} else if (Array.isArray(jwt.role)) {
			isSysAdmin = !!jwt.role.find((r) => r === "sysadmin");
		}
	}

	return isSysAdmin;
};
